import { ArboProperty, PropertyV2Attribute } from "../types"

export function discoverTags(arbo: ArboProperty, attributes: PropertyV2Attribute[], operation: string): string {
  const tags = new Set<string>()

  // Operation
  tags.add(operation)

  // From attributes with tags
  for (const attr of attributes) {
    if (attr.tags) {
      attr.tags.forEach(tag => tags.add(tag))
    }
  }

  // Characteristics to tags mapping
  if (arbo.caracteristicas) {
    const tagMap: Record<string, string> = {
      "piscina": "pool",
      "churrasqueira": "bbq",
      "segurança": "security",
      "portaria": "security",
      "área de lazer": "recreation",
      "playground": "playground",
      "academia": "gym",
      "salão de festas": "party-room",
      "quadra": "court",
      "jardim": "garden",
      "pet place": "pet-friendly",
      "pet": "pet-friendly",
      "mobiliado": "furnished",
      "semi mobiliado": "semi-furnished"
    }

    for (const char of arbo.caracteristicas) {
      const charLower = char.toLowerCase()
      for (const [key, tag] of Object.entries(tagMap)) {
        if (charLower.includes(key)) {
          tags.add(tag)
        }
      }
    }
  }

  // Property type tags
  const tipo = arbo.tipo_imovel?.toLowerCase() || ""
  if (tipo.includes("cobertura")) tags.add("penthouse")
  if (tipo.includes("duplex")) tags.add("duplex")
  if (tipo.includes("triplex")) tags.add("triplex")
  if (tipo.includes("loft")) tags.add("loft")

  // Category tags
  const categoria = arbo.categoria?.toLowerCase() || ""
  if (categoria.includes("residencial")) tags.add("residencial")
  if (categoria.includes("comercial")) tags.add("comercial")

  // Special attributes
  if (arbo.mobiliado) tags.add("furnished")
  if (arbo.permuta) tags.add("exchange")
  if (arbo.financiamento) tags.add("financing")

  return Array.from(tags).join(" ")
}

export function discoverKeywords(arbo: ArboProperty, attributes: PropertyV2Attribute[]): string {
  const keywords = new Set<string>()

  // Basic property info
  if (arbo.codigo) keywords.add(arbo.codigo.toLowerCase())
  if (arbo.tipo_imovel) keywords.add(arbo.tipo_imovel.toLowerCase())
  if (arbo.categoria) keywords.add(arbo.categoria.toLowerCase())

  // Title and description words
  const titleWords = (arbo.titulo || "").toLowerCase().split(/\s+/)
  const descWords = (arbo.descricao || "").toLowerCase().split(/\s+/)
  
  const allWords = [...titleWords, ...descWords]
  allWords.forEach(word => {
    const cleanWord = word.replace(/[^\w]/g, "")
    if (cleanWord.length > 2) {
      keywords.add(cleanWord)
    }
  })

  // Location
  if (arbo.end_cidade) keywords.add(arbo.end_cidade.toLowerCase())
  if (arbo.end_bairro) keywords.add(arbo.end_bairro.toLowerCase())
  if (arbo.end_estado) keywords.add(arbo.end_estado.toLowerCase())

  // Characteristics
  if (arbo.caracteristicas) {
    arbo.caracteristicas.forEach(char => {
      const words = char.toLowerCase().split(/\s+/)
      words.forEach(word => {
        const cleanWord = word.replace(/[^\w]/g, "")
        if (cleanWord.length > 2) {
          keywords.add(cleanWord)
        }
      })
    })
  }

  // Attribute keys and values
  attributes.forEach(attr => {
    if (attr.key) keywords.add(attr.key.replace(/[^a-z0-9]/gi, "-"))
    if (typeof attr.value === "string" && attr.value.length > 2) {
      keywords.add(attr.value.toLowerCase().replace(/[^\w]/g, ""))
    }
  })

  return Array.from(keywords).join(" ")
}